var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row mx-auto border-radius-1 transition-all util-bar"},[_vm._t("utils"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }